import { render, staticRenderFns } from "./created.vue?vue&type=template&id=28a1db6a&scoped=true"
import script from "./created.vue?vue&type=script&lang=js"
export * from "./created.vue?vue&type=script&lang=js"
import style0 from "./created.vue?vue&type=style&index=0&id=28a1db6a&prod&lang=less&scoped=true"
import style1 from "./created.vue?vue&type=style&index=1&id=28a1db6a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a1db6a",
  null
  
)

export default component.exports